import React, { ReactElement } from 'react';
import { JobsiteTabProps } from 'containers/jobsite/types';
import {
  CamerasPanel,
  JobsitePulseProvider,
  JobsitePulseTimelineProvider,
  PulseHeader,
  SnapshotPanel,
  TimelinePanel,
} from './components';
import { pulseMainStyles } from './components/styles';

export function JobsitePulseTabContainer(props: JobsiteTabProps): ReactElement {
  return (
    <JobsitePulseProvider {...props}>
      <div className={pulseMainStyles.root}>
        <PulseHeader />
        <div className={pulseMainStyles.grid}>
          <JobsitePulseTimelineProvider>
            <CamerasPanel />
            <SnapshotPanel />
            <TimelinePanel />
          </JobsitePulseTimelineProvider>
        </div>
      </div>
    </JobsitePulseProvider>
  );
}
